import { Pipe, PipeTransform } from '@angular/core'
import { BinaryOrBase64, toBase64 } from '@lg/shared'

@Pipe({
	name: 'base64',
	standalone: false,
})
export class Base64Pipe implements PipeTransform {
	transform(data: BinaryOrBase64): string {
		return toBase64(data)
	}
}
